<div
    class="bg-{{ highlight }}-{{ shade }} text-{{ highlight }}-{{
        shade
    }}-yiq text-highlight-padding text-highlight-padding--{{
        size
    }} rounded d-flex align-items-center flex-column"
>
    <ng-content></ng-content>
</div>
